import styled from 'styled-components';

export const DeepLinkAgreeCompleteWrapper = styled.div`
  background: #f7f7f7;
  min-height: calc(100vh - 60px);

  .wrapBox {
    background: #fff;
    padding: 30px 20px 40px;
  }
  .titleBox {
    margin-bottom: 30px;
    background: #fff;
    .title {
      padding-bottom: 14px;
      font-size: 1.8rem;
      font-weight: 500;
    }
    .subtitle {
      color: #666;
      font-size: 1.3rem;
      line-height: 2rem;
    }
  }
  dl {
    margin-bottom: 30px;
    padding: 20px;
    background-color: #f5f5f5;
    font-size: 1.3rem;
    line-height: 2.2rem;
    border-radius: 10px;
    dt {
      display: flex;
      align-items: center;
      gap: 4px;
      font-weight: 500;
    }
    dd {
      span {
        color: #02a4ff;
      }
    }
  }

  .btnMoreMall {
    width: 100%;
    height: 64px;
    margin-bottom: 20px;
    background-color: #02a4ff;
    border-radius: 10px;
    color: #fff;
    text-align: center;
    font-size: 1.6rem;
    font-weight: 500;
    span {
      font-size: 1.2rem;
      color: #fff;
      font-weight: 400;
    }
  }

  .btnDataManage {
    width: 100%;
    height: 44px;
    background-color: #f1f1f1;
    border-radius: 10px;
    text-align: center;
    font-weight: 500;
  }
`;
